import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";
import {ChildRoles, MessageFilters, MessageType} from "root/DataFunctions/Constants";
import phpVars from 'phpVars';
import {UserTypes} from "root/DataFunctions/Constants";

// Augustine
export const getMessageReplyThread = (date_created, reply_to_post_id, onCompleteFunc) => {
    const url = Globals.APIFolder + '/message/'  + reply_to_post_id + '/replyThread?date_created=' + date_created

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
};

export const getMyContacts = ( user_type, status, onCompleteFunc) =>
{
    const adults_only = user_type !== UserTypes.CHILD;
    const url = Globals.APIFolder + '/users/current/contacts?user_role=' + ChildRoles.MESSAGER+ '&adults_only=' + adults_only + '&direction=send&status=' + status;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

// Gte the contact details for a single contact. This API will validate that the caller has permissions to see this
export const getContactDetails = ( user_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/current/contacts/' + user_id + '/details';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

// This is THE definitive contact message API call to get all messages
//
// ** DO NOT ** under ANY circumstances write another message fetch API function  without discussing with Neil FIRST
//
export const getContactMessages = ( user_id, contact_id, filter, message_type, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/contacts/' + contact_id + '/messages?filter=' + filter + '&message_type=' + message_type ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

export const getMonitoringMessages = ( user_id, contact_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id + '/contacts/' + contact_id + '/messages?filter=' + MessageFilters.BOTH + '&message_type=' + MessageType.MESSAGE_TYPE_MESSAGE ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

